module.exports = __webpack_public_path__ + "img/logo.a525f73d.svg";